<template>
  <!-- 供货商门户登录页:居中卡片布局,与管理后台登录页(深色右侧卡片)视觉区分 -->
  <div class="supplier-login">
    <div class="supplier-login__card">
      <div class="supplier-login__logo">
        <i class="el-icon-shopping-bag-1"></i>
      </div>
      <div class="supplier-login__title">权益商城·供货商平台</div>
      <div class="supplier-login__subtitle">订单发货管理</div>
      <el-form ref="loginForm" :model="form" :rules="rules" @submit.native.prevent="submitLogin">
        <el-form-item prop="account">
          <el-input v-model.trim="form.account" prefix-icon="el-icon-user" placeholder="请输入账号"
            autocomplete="username" clearable></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model.trim="form.password" prefix-icon="el-icon-lock" placeholder="请输入密码" show-password
            autocomplete="current-password" @keyup.enter.native="submitLogin"></el-input>
        </el-form-item>
        <el-button type="primary" class="supplier-login__btn" :loading="loginLoading" @click="submitLogin">登 录
        </el-button>
      </el-form>
      <div class="supplier-login__tip">仅限平台合作供货商使用，账号问题请联系平台</div>
    </div>
  </div>
</template>

<script>
import { supplierPortalLogin } from "../../api/api";

export default {
  name: "SupplierLogin",
  data() {
    return {
      loginLoading: false,
      form: {
        account: "",
        password: "",
      },
      rules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  activated() {
    // 顶层router-view被keep-alive缓存:每次进入登录页都校验,已登录直接进订单页
    document.title = "权益商城·供货商平台";
    if (sessionStorage.getItem("supplierToken")) {
      this.$router.replace("/supplier/orders");
    }
  },
  methods: {
    submitLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.loginLoading = true;
        supplierPortalLogin(this.form).then((res) => {
          this.loginLoading = false;
          if (!res || res.status !== 200) {
            // 失败原样返回:直接展示后端msg(账号或密码错误/账号已禁用等)
            this.$message.error((res && res.msg) || "登录失败,请稍后重试");
            return;
          }
          // 供货商登录态独立存储(sessionStorage,会话级),不与管理后台localStorage的Qy_token冲突
          sessionStorage.setItem("supplierToken", res.data.userAes);
          sessionStorage.setItem("supplierName", res.data.amsName || "");
          this.$message.success("登录成功");
          this.$router.replace("/supplier/orders");
        }).catch(() => {
          this.loginLoading = false;
        });
      });
    },
  },
};
</script>

<style scoped>
.supplier-login {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #eef4ff 0%, #e8f7f1 55%, #f5f0ff 100%);
  padding: 24px 16px;
  overflow-y: auto;
}

.supplier-login__card {
  width: 400px;
  max-width: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(31, 60, 122, 0.12);
  padding: 40px 36px 28px;
  text-align: center;
}

.supplier-login__logo {
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 0 auto 14px;
  border-radius: 14px;
  background: linear-gradient(135deg, #3a7afe, #6ac6ff);
  color: #fff;
  font-size: 30px;
}

.supplier-login__title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2d3d;
}

.supplier-login__subtitle {
  margin: 6px 0 26px;
  font-size: 13px;
  color: #8a97a8;
}

.supplier-login__btn {
  width: 100%;
  font-size: 16px;
  height: 44px;
  margin-top: 4px;
}

.supplier-login__tip {
  margin-top: 18px;
  font-size: 12px;
  color: #a8b3c1;
}

/* 手机端(<=768px):卡片占满宽度,触控区与字号适当放大 */
@media (max-width: 768px) {
  .supplier-login__card {
    padding: 32px 22px 22px;
  }

  .supplier-login__title {
    font-size: 19px;
  }
}
</style>
